import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiPython,
  DiGit,
  DiDocker,
  DiJava,
  DiNginx,
} from "react-icons/di";
import { SiAmazonaws, SiMysql, SiOpenai, SiRedis } from "react-icons/si";
// Official dark-background logo from https://www.langchain.com/brand-assets
import langchainLogo from "../../Assets/langchain.svg";

const developmentSkills = [
  { name: "Java", Icon: DiJava },
  { name: "JavaScript", Icon: DiJavascript1 },
  { name: "Python", Icon: DiPython },
  { name: "Docker", Icon: DiDocker },
  { name: "Git", Icon: DiGit },
  { name: "Redis", Icon: SiRedis },
  { name: "MySQL", Icon: SiMysql },
  { name: "Nginx", Icon: DiNginx },
];

const cloudAndAiSkills = [
  { name: "AWS", Icon: SiAmazonaws },
  { name: "OpenAI", Icon: SiOpenai },
  { name: "LangChain", image: langchainLogo },
];

function SkillTile({ name, Icon, image }) {
  return (
    <Col xs={4} md={2} className="tech-icons skill-tile" role="img" aria-label={name}>
      <span className="skill-icon" aria-hidden="true">
        {Icon ? <Icon /> : <img src={image} alt="" loading="lazy" />}
      </span>
      <span className="skill-label" aria-hidden="true">{name}</span>
    </Col>
  );
}

function Techstack() {
  return (
    <>
      <Row className="skillset-row" aria-label="Development technologies">
        {developmentSkills.map((skill) => <SkillTile key={skill.name} {...skill} />)}
      </Row>
      <h2 className="skillset-group-heading">Cloud & AI</h2>
      <Row className="skillset-row skillset-row--last" aria-label="Cloud and AI platforms">
        {cloudAndAiSkills.map((skill) => <SkillTile key={skill.name} {...skill} />)}
      </Row>
    </>
  );
}

export default Techstack;
